(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["local-atelier"] && !Shopify.designMode) return;
  try {
    
function initializeArtReview(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const key = root.dataset.storageKey;
  const inputs = Array.from(root.querySelectorAll('[data-art-choice]'));
  const status = root.querySelector('[data-review-status]');
  let saved = null;
  try { saved = JSON.parse(localStorage.getItem(key)); } catch (error) { saved = null; }
  if (Array.isArray(saved)) inputs.forEach(input => { input.checked = saved.includes(input.value); });
  root.addEventListener('change', event => {
    if (!event.target.matches('[data-art-choice]')) return;
    try { localStorage.setItem(key, JSON.stringify(inputs.filter(input => input.checked).map(input => input.value))); } catch (error) { return; }
  });
  root.querySelector('[data-export-selection]').addEventListener('click', () => {
    const selected = inputs.filter(input => input.checked).map(input => ({ artwork_id: input.value, title: input.dataset.title, version: input.value.split('-').pop() }));
    const data = { project: 'València', review: '2026-09-27-coherence-c2', generated_at: new Date().toISOString(), status: 'preferences_to_review', selected, publication_authorized: false };
    const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }));
    const anchor = document.createElement('a'); anchor.href = url; anchor.download = 'selection-valencia.json'; anchor.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    status.textContent = selected.map(item => item.artwork_id + ' — ' + item.title).join(' / ') || root.dataset.emptyMessage;
  });
}
document.querySelectorAll('[data-art-review]').forEach(initializeArtReview);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-art-review]').forEach(initializeArtReview));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-home"] && !Shopify.designMode) return;
  try {
    
function initOrenoaCollections(scope = document) {
 scope.querySelectorAll('.el-home').forEach(root => {
  if (root.dataset.filtersReady) return;
  const cards = [...root.querySelectorAll('.el-works [data-art-category]')];
  const tools = root.querySelector('[data-collection-tools]');
  if (!tools || !cards.length) return;
  root.dataset.filtersReady = 'true'; tools.hidden = false;
  const status = root.querySelector('.el-result-count');
  const update = category => {
   let count = 0;
   cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.artCategory !== category; if (!card.hidden) count++; });
   root.querySelectorAll('[data-art-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.artFilter === category)));
   status.textContent = count + ' ' + (count === 1 ? root.dataset.resultLabel.replace(/s$/, '') : root.dataset.resultLabel);
  };
  root.querySelectorAll('[data-art-filter]').forEach(button => button.addEventListener('click', () => update(button.dataset.artFilter)));
  root.querySelectorAll('[data-set-purchase]').forEach(button => {
   button.hidden = false;
   button.addEventListener('click', async () => {
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const pair = button.closest('.el-pair');
    const error = pair.querySelector('.el-pair-error');
    error.hidden = true;
    try {
     const response = await fetch(root.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:button.dataset.variants.split(',').filter(Boolean).map(id=>({id,quantity:1}))})});
     if (!response.ok) throw new Error('Cart update not confirmed');
     window.location.assign(root.dataset.cartUrl);
    } catch (_) {
     error.textContent = root.dataset.pairError; error.hidden = false;
     pair.querySelector('[data-review-cart]').hidden = false;
     button.removeAttribute('aria-busy');
     button.disabled=false;
    }
   });
  });
  update('all');
 });
}
initOrenoaCollections();
document.addEventListener('shopify:section:load', () => initOrenoaCollections());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orenoa-room"] && !Shopify.designMode) return;
  try {
    
function initOrenoaRooms(){
 document.querySelectorAll('.oa-room').forEach(room=>{
  if(room.dataset.ready)return;
  room.dataset.ready='true';
  const variants=JSON.parse(room.querySelector('[data-oa-variants]').textContent);
  const id=room.dataset.productId;
  const sync=()=>{
   const chosen=[0,1].map(index=>document.querySelector('input[type="radio"][name$="-'+id+'"][data-fieldset-index="'+index+'"]:checked')?.value);
   const variant=variants.find(item=>item.options.every((option,index)=>option===chosen[index]));
   if(!variant||!variant.image)return;
   const image=room.querySelector('.oa-room-preview');
   image.removeAttribute('srcset');
   image.src=variant.image;
   image.alt=variant.title;
   room.querySelector('.oa-room-selection').textContent=variant.title;
  };
  sync();
  document.addEventListener('change',event=>{if(event.target?.name?.endsWith('-'+id))sync();});
 });
}
initOrenoaRooms();
document.addEventListener('shopify:section:load',initOrenoaRooms);

  } catch(e) { console.error(e); }
})();
})();
